<script setup lang="ts">
import { type Component, computed } from "vue";

import DropdownMenu from "~/components/dumb/DropdownMenu.vue";
import DropdownMenuItemContent from "~/components/dumb/DropdownMenuItemContent.vue";
import { CheckIcon, ChevronDownIcon } from "~/icons";
import { DropdownMenuItemKind } from "~/shared/enums";
import { usePageStore } from "~/stores";

const props = defineProps<{
  options: {
    title: string;
    subtitle?: string;
    selected: boolean;
    iconAfter?: Component;
    iconAfterArgs?: object;
    onClick: () => void;
  }[];
  noChevron?: boolean;
  border?: boolean;
  block?: boolean;
  widthPixels?: number;
  isSettingsMode?: boolean;
}>();

const pageStore = usePageStore();

const dropdownSections = computed(() => [
  {
    title: "Selections",
    items: props.options.map(({ title, subtitle, selected, iconAfter, iconAfterArgs, onClick }) => {
      const baseItem = { title, subtitle, selected, onClick };
      return {
        ...baseItem,
        kind: DropdownMenuItemKind.COMPONENT,
        component: DropdownMenuItemContent,
        componentArgs: {
          ...baseItem,
          icon: !pageStore.isMobile ? CheckIcon : undefined,
          iconArgs: {
            class: `icon-sm text-lt${selected ? "" : " invisible"}`,
          },
          iconAfter,
          iconAfterArgs,
          showIconAfterOnHover: true,
        },
      };
    }),
  },
]);
</script>

<template>
  <DropdownMenu :sections="dropdownSections" :block="block" :distance="2" :width-pixels="widthPixels">
    <div
      class="flex size-full items-center justify-between bg-std text-md hover:bg-lt"
      :class="[border && 'border border-md', isSettingsMode ? 'rounded-md shadow-xs' : 'rounded']">
      <slot />
      <ChevronDownIcon v-if="!noChevron" class="mx-1 icon-sm text-lt print:hidden" />
    </div>
  </DropdownMenu>
</template>
